module.exports = __webpack_public_path__ + "img/binary_to_decimal.576ba933.png";